import { t } from '../i18n';
import { Spinner } from './ui/spinner';

export function EmptyState({ children }: { children?: React.ReactNode }) {
  return <div className="empty">{children ?? t.noData}</div>;
}

export function LoadingState({ message }: { message?: string }) {
  return (
    <div className="empty flex flex-col items-center justify-center gap-3 py-12">
      <Spinner size="lg" />
      {message && <span className="text-xs text-dim font-medium">{message}</span>}
    </div>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : t.requestFailed;
  return <div className="errorbox" role="alert">{message}</div>;
}
